import React from "react";

import styles from "./routeFallback.module.css";

const RouteFallback = () => {
  return (
    <div className={styles.container} role="status" aria-live="polite" aria-label="Loading page">
      <div className={styles.spinner} />
    </div>
  );
};

export default RouteFallback;
